import {
  GET_ALL_DEVICES_SUCCESS,
  CREATE_DEVICE_SUCCESS,
  EDIT_DEVICE_SUCCESS,
  DELETE_DEVICE_SUCCESS,
  UPDATE_DEVICE_DATA,
  SET_ALL_DEVICES_SUCCESS,
  SET_INDIVIDUAL_DEVICE_SUCCESS,
  SET_CONFIGURATION_SUCCESS,
  UPDATE_CONFIGURATION_OPTIONS_SUCCESS
} from './actions';

const initialState = {
  devices: [],
  configuration: {
    mupListPollRate: null,
    edevListPollRate: null
  }
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_DEVICES_SUCCESS:
    case EDIT_DEVICE_SUCCESS:
    case DELETE_DEVICE_SUCCESS:
    case CREATE_DEVICE_SUCCESS:
    case UPDATE_DEVICE_DATA:
    case SET_ALL_DEVICES_SUCCESS:
    case SET_INDIVIDUAL_DEVICE_SUCCESS:
      return {
        ...state,
        devices: action.data
      };

    case SET_CONFIGURATION_SUCCESS:
    case UPDATE_CONFIGURATION_OPTIONS_SUCCESS:
      return {
        ...state,
        configuration: action.data
      };
    default:
      return state;
  }
};

export default reducer;
